export const tedeeConfig = {
  common: {
    saving: "Zapisywanie...",
    connected: "Połączono",
    disconnected: "Rozłączono",
    lockFallbackNamed: "Zamek {id}",
    deviceFallbackNamed: "Urządzenie Tedee {id}",
    unitFallback: "Jednostka",
    unitFallbackNamed: "Jednostka {id}",
  },

  credentials: {
    title: "Konfiguracja Tedee",
    apiVersionInUse: "Używana wersja API:",
    savedKey: "Klucz zapisany",
    noKey: "Brak klucza",
    keyLabel: "Personal Access Key",
    keyPlaceholderSaved: "•••••••• (zapisany, zmiana opcjonalna)",
    keyPlaceholderNew: "Wprowadź swój Personal Access Key z Tedee",
    keyHintSaved: "Można zostawić puste, jeśli klucz jest już zapisany.",
    keyHintNew: "Klucz można pobrać w portalu Tedee.",
    testing: "Testowanie...",
    test: "Testuj połączenie",
    save: "Zapisz dane dostępowe",
  },

  selector: {
    title: "Wybór zamków dla tego obiektu",
    subA: "Wybierz tylko te zamki, które dotyczą",
    subBold: "tego obiektu",
    subB: ". W PMS będą widoczne wyłącznie zamki wybrane tutaj.",
    selectedCount: "Wybrano: {count}",
    hintNoKeyA: "Wprowadź swój Personal Access Key i naciśnij",
    hintNoKeyBold: "Testuj połączenie",
    hintNoKeyB: ", aby wczytać zamki.",
    emptyDevices:
      "Nie znaleźliśmy żadnego zamka ani bramy na koncie Tedee. Upewnij się, że urządzenie jest zarejestrowane i udostępnione kontu, którego klucz został zapisany powyżej.",
    placeholder: "Wybierz zamki…",
    summaryCount: "Wybrane zamki: {count}",
    summaryEmpty: "Nie wybrano żadnych zamków",
    save: "Zapisz zamki dla tego obiektu",
  },

  pms: {
    title: "Sterowanie i przypisanie (PMS)",
    subA:
      "Widoczne są tu tylko zamki zapisane dla tego obiektu. Przypisz każdy z nich do opcji",
    subBold1: "Drzwi główne",
    subOr: "lub",
    subBold2: "Jednostka",
    subEnd: ".",
    assignedCount: "Przypisano: {count}",
    empty: {
      A: "Dla tego obiektu nie ma jeszcze zapisanych zamków. Skorzystaj z",
      bold: "selektora",
      B: "powyżej, a następnie zapisz.",
    },
    assignmentLabel: "Przypisanie",
    assignmentNone: "Nieprzypisany",
    assignmentGate: "Drzwi główne (brama)",
    assignmentCommon: "Drzwi główne (wspólne)",
    assignmentUnit: "Drzwi apartamentu",
    hintNone: "Nie będzie sterowany z PMS.",
    hintGate: "Brama: można ją tylko otworzyć impulsem (brak obsługi zamykania i PIN-ów).",
    hintUnit: "Zostanie powiązany z tym obiektem na potrzeby sterowania i PIN-ów.",
    unitLabel: "Jednostka / zakwaterowanie",
    unitSelect: "Wybierz jednostkę",
    unitHint: "Wybierz, którą jednostkę otwiera ten zamek.",
    nameLabel: "Nazwa (opcjonalnie)",
    namePlaceholder: "Np. Drzwi główne / Ap. 101",
    nameHint: "Ta nazwa zostanie zapisana przy ponownym zapisie wyboru zamków.",
    actions: {
      lock: "Zamknij",
      unlock: "Otwórz",
      createPin: "Utwórz PIN",
      pinHistory: "Historia PIN-ów",
      openGate: "Otwórz bramę (impuls)",
      refresh: "Odśwież status",
    },
    save: "Zapisz przypisanie",
    tipA: "Wskazówka: przypisz drzwi główne lub jednostkę i naciśnij",
    tipBold: "Zapisz przypisanie",
    tipB: ". Przyciski staną się aktywne po przypisaniu urządzenia.",
  },

  pinHistory: {
    title: "Historia PIN-ów",
    loading: "Wczytywanie historii…",
    empty: "Brak zapisanych PIN-ów dla tego zamka.",
    colAlias: "Alias",
    colPin: "PIN",
    colValidity: "Ważność",
    colState: "Status",
    createdPrefix: "Utworzono:",
    fromLabel: "Od:",
    toLabel: "Do:",
    revokeTitle: "Usuń / unieważnij PIN",
    noteA: '* Status „Aktywny” jest wyliczany przez porównanie bieżącej daty i godziny z',
    noteMid: "oraz",
    noteEnd: ".",
    close: "Zamknij",
  },

  pinModal: {
    title: "Utwórz PIN",
    nameLabel: "Nazwa / etykieta",
    namePlaceholder: "Np. Sprzątanie / Gość / Technik",
    pinLabel: "PIN",
    pinPlaceholder: "6 cyfr",
    generateTitle: "Generuj",
    pinHint: "Jeśli pole pozostanie puste, PIN wygeneruje backend.",
    modeLabel: "Tryb",
    modeTimeLimited: "Z datami",
    modeOngoing: "Bez dat (do unieważnienia)",
    validFrom: "Ważny od",
    validTo: "Ważny do",
    tipLabel: "Wskazówka:",
    tipText: "Dla gościa użyj PIN-u z datami check-in i check-out.",
    cancel: "Anuluj",
    creating: "Tworzenie...",
    create: "Utwórz PIN",
  },

  toast: {
    noLocksFound: "Nie znaleziono w Tedee żadnych zamków (typ 2/5).",
    loadStatusError: "Nie udało się wczytać statusu zamka",
    loadStatusError2: "Błąd podczas wczytywania statusu zamka",
    needKey: "Należy wprowadzić Personal Access Key lub mieć zapisany klucz.",
    connectionOk: "Połączenie udane. Znaleziono urządzenia: {count}.",
    testError: "Błąd podczas testowania połączenia",
    needValidKey:
      "Należy wprowadzić prawidłowy Personal Access Key (co najmniej 10 znaków).",
    credentialsSaved: "Dane dostępowe zostały zapisane",
    saveCredentialsError: "Błąd podczas zapisywania danych dostępowych",
    saveCredentialsErrorPrefix: "Błąd podczas zapisywania danych dostępowych: ",
    needOneDevice: "Należy wybrać co najmniej jedno urządzenie dla tego obiektu.",
    devicesSaved: "Urządzenia zapisane dla tego obiektu",
    devicesSaveError: "Nie udało się zapisać urządzeń",
    saveErrorPrefix: "Błąd podczas zapisywania: ",
    gateNoLock:
      "Brama (typ 5) nie obsługuje zamykania. Można ją tylko otworzyć impulsem.",
    locked: "Zamek zamknięty",
    lockError: "Nie udało się zamknąć",
    lockError2: "Błąd podczas zamykania",
    gateOpened: "Brama otwarta (impuls)",
    unlocked: "Zamek otwarty",
    unlockError: "Nie udało się otworzyć",
    unlockError2: "Błąd podczas otwierania",
    needUnitForApartment:
      "Wybierz jednostkę dla zamków przypisanych jako 'Drzwi apartamentu'.",
    bindingsSaved: "Przypisanie zostało zapisane",
    bindingsSaveError: "Nie udało się zapisać przypisania",
    bindingsSaveErrorPrefix: "Błąd podczas zapisywania przypisania: ",
    gateNoPin: "Brama (typ 5) nie obsługuje PIN-ów.",
    assignFirst:
      "Najpierw przypisz zamek (drzwi główne lub jednostka) i zapisz, aby włączyć sterowanie.",
    needPinName: "Należy podać nazwę/etykietę PIN-u.",
    needValidDates: "Należy podać datę ważności od i do.",
    pinCreated: "PIN został utworzony",
    pinCreateError: "Nie udało się utworzyć PIN-u",
    pinCreateError2: "Błąd podczas tworzenia PIN-u",
    gateNoPinHistory: "Brama (typ 5) nie obsługuje historii PIN-ów.",
    historyLoadError: "Nie udało się wczytać historii",
    historyLoadError2: "Błąd podczas wczytywania historii",
    noProviderPinId:
      "Ten PIN nie ma provider_pin_id. Nie można go unieważnić w Tedee.",
    pinRevoked: "PIN unieważniony",
    revokeError: "Nie udało się unieważnić",
    revokeError2: "Błąd podczas unieważniania PIN-u",
  },

  confirm: {
    revokePin: 'Czy na pewno unieważnić/usunąć PIN „{alias}”?',
  },

  pinState: {
    active: "Aktywny",
    upcoming: "Nadchodzący",
    expired: "Wygasły",
    revoked: "Unieważniony",
    none: "Bez dat",
  },
};
